module.exports = __webpack_public_path__ + "static/NeueMontreal-LightItalic-517c56e029e9f88f42ffae5afd3a60f6.woff2";